<template>
  <div>
    <Page404></Page404>
  </div>
</template>

<script>

import {
  default as Page404
} from '@/wam/components/widgets/Page404';
import { mapGetters } from 'vuex';
export default {
  name: 'page404',
  computed: mapGetters({
    StoreLang: 'StoreLang',
  }),
  components: {
    Page404
  },
  props: {},
  data () {
    return {};
  },
  created: function () {},
  beforeMount () {},
  mounted: function () {},
  methods: {},
  watch: {}
}

</script>

